import React from 'react';
import {Box, Typography, useTheme} from '@mui/material';

import Icon from 'presentation/icons';
import {Loading} from 'presentation/components/Loading/Loading';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {DownloadContainer} from './styles';
import {DownloadDocumentProps} from '../types';

export function DownloadDocument({label, onClick, loading}: DownloadDocumentProps) {
	const theme = useTheme();

	return (
		<DownloadContainer data-tag-id={AutoSolEnum.AS_CLICK_DOWNLOAD}>
			<Typography>{label}</Typography>{' '}
			{loading ? (
				<Box width={20}>
					<Loading sx={{color: theme.palette.action.disabled}} size={20} />
				</Box>
			) : (
				<Icon name="download" color={theme.palette.primary.main} onClick={onClick} />
			)}
		</DownloadContainer>
	);
}
